import { _ as s } from "./index742.mjs";
import { f as c } from "./index746.mjs";
import "./index747.mjs";
import { t as p } from "./index748.mjs";
import { t as m } from "./index749.mjs";
import { n as g } from "./index750.mjs";
import { r as v } from "./index751.mjs";
import { c as f } from "./index752.mjs";
import { __exports as u } from "./index753.mjs";
var h = s, l = c, _ = u.f, L = p, a = m, x = g, O = v, R = f, b = l("".slice), C = Math.min, n = R("startsWith"), d = !n && !!function() {
  var r = _(String.prototype, "startsWith");
  return r && !r.writable;
}();
h({ target: "String", proto: !0, forced: !d && !n }, {
  startsWith: function(t) {
    var e = a(O(this));
    x(t);
    var o = L(C(arguments.length > 1 ? arguments[1] : void 0, e.length)), i = a(t);
    return b(e, o, o + i.length) === i;
  }
});
